import type { ISubCategory } from 'garden-common';
import {api} from "./index";

export interface DataApiSearchSubcats {
  subcategories: ISubCategory[];
}

export async function apiSearchSubcats(searchString: string, categoryName?: string) {
  const res = await api.get(`v2/subcategory/all/${searchString}`, {
    params: { ...(searchString && { limit: 100 }), ...(categoryName && { categoryName }) }
  });
  return res.data;
}

export const getAllSubcategories = async (
  limit: number,
  text: string = 'null',
  postCounts = false
) => {
  return await api
    .get(`/v2/subcategory/all/${text}`, { params: { limit: limit, postCounts } })
    .then(res => {
      return res.data.subcategories as ISubCategory[];
    });
};

export const createSubcategory = async (data: ISubCategory) => {
  try {
    const ret = await api.post(`/v2/subcategory/create`, data).then(res => {
      if (res.status === 201) {
        return res.data.subcategory;
      } else {
        return res;
      }
    });
    return ret;
  } catch (error) {
    return error.response?.data?.errors;
  }
};

export const updateSubCategory = async (id: string, data: { updates; }) => {
  try {
    const ret = await api.put(`/v2/subcategory/update/${id}`, data).then(res => {
      if (res.status === 201) {
        return res.data.subcategory;
      } else {
        return res;
      }
    });
    return ret;
  } catch (error) {
    return error.response?.data?.errors;
  }
};

export const deleteSubcategory = async (id: string) => {
  return await api.delete(`/v2/subcategory/create/${id}`).then(res => {
    return res.data.subcategories;
  });
};
